/** @flow */

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";

type OwnProps = $Exact<{
  onDismissHandler: () => void,
  onSubmit: (status: boolean) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const ConfirmResetPasswordModal = (props: Props) => (
  <Modal className="modal-small">
    <ModalHeader toggle={props.onDismissHandler}>{props.t("RESET_PASSWORD")}</ModalHeader>
    <ModalBody className="d-flex justify-content-center align-items-center">
      <p className="normal-font-size">{props.t("CONFIRM_RESET_PASSWORD_TEXT")}</p>
    </ModalBody>
    <ModalFooter>
      <Button onClick={props.onDismissHandler} color="secondary">
        {props.t("CANCEL")}
      </Button>
      <Button onClick={props.onSubmit}>{props.t("RESET")}</Button>
    </ModalFooter>
  </Modal>
);

export default localize()(ConfirmResetPasswordModal);
